import {
    OverlayComponent as SourceOverlayComponent,
} from 'SourceComponent/Overlay/Overlay.component';

import './Overlay.override.style';
import { toggleScroll } from '@scandipwa/scandipwa/src/util/Browser';

export class OverlayComponent extends SourceOverlayComponent {
    freezeScroll() {
        this.YoffsetWhenScrollDisabled = window.pageYOffset || document.body.scrollTop;
        toggleScroll(false);
        // document.body.style.marginTop = `${-this.YoffsetWhenScrollDisabled}px`;
    }

    unfreezeScroll() {
        toggleScroll(true);
        // document.body.style.marginTop = '0';
        window.scrollTo(0, this.YoffsetWhenScrollDisabled);
    }
}

export default OverlayComponent;
